export const STAY_SAFE  ='/stay_safe';
export const CHILD_PROTECTION ='/child_protection';
export const POLICY_PATH=[
    STAY_SAFE,
    CHILD_PROTECTION
]
